import { isProductAvailableForAutoship, useProduct } from '@/entities/product';

export const usePromoList = () => {
    const MINIMUM_DISPLAY_PROMOS = 2;

    const { product } = useProduct();

    let promotions = (product?.promotions ?? []).filter(promo => Boolean(promo.text?.trim()));

    if (!product || !isProductAvailableForAutoship(product)) {
        promotions = promotions.filter(promo => {
            return promo.type?.toLowerCase() !== 'autoship';
        });
    }

    const promosToDisplay = promotions.slice(0, MINIMUM_DISPLAY_PROMOS);
    const promosToHide = promotions.slice(MINIMUM_DISPLAY_PROMOS);
    const hasPromosDetails = promotions.some(promo => Boolean(promo.key));

    return {
        promosToDisplay,
        promosToHide,
        hasPromosDetails,
    };
};
